"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = intervalFromCustomRange;

var _moment = _interopRequireDefault(require("moment"));

var _FixedRanges = _interopRequireDefault(require("./FixedRanges.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @desc Check if the custom interval interval selected matches one
 * of our supported ranges and if so returns the proper one.
 * @param {Object} dates
 * @returns {String | null} Interval if found, null if not
 */
function intervalFromCustomRange(dates) {
  var start = _moment["default"].isMoment(dates.startDate) ? dates.startDate : (0, _moment["default"])(dates.startDate);
  var end = _moment["default"].isMoment(dates.endDate) ? dates.endDate : (0, _moment["default"])(dates.endDate);
  var timeInterval = null;

  var firstDayOfMonth = function firstDayOfMonth(date) {
    return date.date() === 1;
  };

  var lastDayOfMonth = function lastDayOfMonth(date) {
    return date.date() === date.clone().endOf('month').date();
  };

  if (start.isSame(end)) {
    timeInterval = 'day';
  } else if (start.isSame(end, 'week') && start.day() === 0 && end.day() === 6) {
    timeInterval = 'week';
  } else if (start.isSame(end, 'month') && firstDayOfMonth(start) && lastDayOfMonth(end)) {
    timeInterval = 'month';
  } else if (start.isSame(_FixedRanges["default"].all.start(), 'day') && end.isSame(_FixedRanges["default"].all.end(), 'day')) {
    timeInterval = 'all';
  } else {
    timeInterval = 'custom';
  }

  return timeInterval;
}

//# sourceMappingURL=IntervalFromCustomRange.js.map